<script>
	import TileContainer from "../custom/tile-container.vue";
	import Tile from "../custom/tile.vue";

	export default {
    	props: [
			"namingIsHard"
        ],
		render(component) {
			return component({
                components: {
					"readmore": () => System.import("../custom/readmore.vue"),
					"image-info": () => System.import("../custom/image-info.vue"),
					"post-card": () => System.import('../custom/post-card.vue'),
					"album": () => System.import("../custom/album.vue"),
					"tile-container": () => System.import("../custom/tile-container.vue"),
					"tile": () => System.import("../custom/tile.vue")
                },
				template: `<article class="content">${this.namingIsHard}</article>`
            });
		}
    }
</script>


// WEBPACK FOOTER //
// article-content.vue?e654dc1a